import request from '@/utils/request'

// 取得红点泡泡数量
export function unallocatedAll() {
  return request({
    url: '/Unallocated/all',
    method: 'get',
  })
}

// 商户帐变列表 
export function listAppBalanceChangeDetails(params) {
  return request({
    url: '/app/listAppBalanceChangeDetails',
    method: 'get',
    params: params,
  })
}

// 线下商户下分 
export function appRecycle(data) {
  return request({
    url: '/app/recycle',
    method: 'post',
    data: data,
  })
}

// 线下商户上分
export function appTopUp(data) {
  return request({
    url: '/app/topUp',
    method: 'post',
    data: data,
  })
}

// 取得版本资讯列表
export function getVersionList(params) {
  return request({
    url: '/version/list',
    method: 'get',
    params: params,
  })
}

// 新增版本
export function addVersion(data) {
  return request({
    url: '/version/addVersion',
    method: 'post',
    data: data,
  })
}

// 更新版本
export function updateVersion(id, data) {
  return request({
    url: `/version/updateVersion/${id}`,
    method: 'post',
    data: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/app.js